export default {
    document: '',
    name: '',
    email: '',
    phone: '',
    celPhone: '',
}


// WEBPACK FOOTER //
// ./src/shared/modules/CustomerNew/vuex/state.js